<template>
  <div class="body" @click="save">
    <div class="pdf-wrapper" ref="reportSummary2">
      <div class="container">
        <header class="no-margin">
          <h1>Project [DEMO - Brand Detection] PFL</h1>
          <img src="./img/Logos_TXT.svg" alt="" class="logo">
        </header>
        <div class="page-row mt-45">
          <div class="side-content-2">
            <div>
              <div class="content-heading">EXPOSURE TIME, s</div>
              <div id="exp-time-s"></div>
            </div>
          </div>
          <div class="main-content-2">
            <div class="content-heading--sec">Exposure Time — absolute total time in seconds that the brand was on the screen.</div>
            <div class="table pt-20">
              <div class="table-row no-border no-padding no-margin" v-for="(item, index) in report" :key="item.brand + index">
                <div class="table-cell"  style="width: 10px">{{index + 1}}</div>
                <div class="table-cell"  style="width: 100px;text-align: left">{{item.brand}}</div>
                <div class="table-cell"  style="width: 40px;text-align: right">{{item.exposure_time_sec.toFixed(1)}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="page-row">
          <div class="side-content-2">
            <div>
              <div class="content-heading">EXPOSURE TIME, %</div>
              <div id="exp-time-percent"></div>
            </div>
          </div>
          <div class="main-content-2">
            <div class="content-heading--sec">Exposure Time — percentage time (relative to the total video duration) that the brand was on the screen.</div>
            <div class="table pt-20">
              <div class="table-row no-border no-padding no-margin" v-for="(item, index) in report" :key="item.brand + index + '2'">
                <div class="table-cell"  style="width: 10px">{{index + 1}}</div>
                <div class="table-cell"  style="width: 100px;text-align: left">{{item.brand}}</div>
                <div class="table-cell"  style="width: 40px;text-align: right">{{item.exposure_time_pct.toFixed(1)}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="page-row">
          <div class="side-content-2">
            <div>
              <div class="content-heading">MEAN AREA, %</div>
              <div id="mean-area-percent"></div>
            </div>
          </div>
          <div class="main-content-2">
            <div class="content-heading--sec">Mean Area — brand logo area averaged over full length of video, relative to full video size. </div>
            <div class="table pt-20">
              <div class="table-row no-border no-padding no-margin" v-for="(item, index) in report" :key="item.brand + index + '3'">
                <div class="table-cell"  style="width: 10px">{{index + 1}}</div>
                <div class="table-cell"  style="width: 100px;text-align: left">{{item.brand}}</div>
                <div class="table-cell"  style="width: 40px;text-align: right">{{item.mean_area_pct.toFixed(1)}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="page-row">
          <div class="side-content-2">
            <div>
              <div class="content-heading">BIS</div>
              <div id="bis"></div>
            </div>
          </div>
          <div class="main-content-2">
            <div class="content-heading--sec">BIS — Brand Impact Score (for more information, see Page 5).</div>
            <div class="table pt-20">
              <div class="table-row no-border no-padding no-margin" v-for="(item, index) in report" :key="item.brand + index + '4'">
                <div class="table-cell"  style="width: 10px">{{index + 1}}</div>
                <div class="table-cell"  style="width: 100px;text-align: left">{{item.brand}}</div>
                <div class="table-cell"  style="width: 40px;text-align: right">{{item.bis.toFixed(1)}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="pdf-footer">
          <span>{{project.project_name}}</span>
          <span>Page 2 / 3</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import ApexCharts from 'apexcharts';
  import { getOptions } from "../../utils/apexchart/chart-options";
  import html2canvas from "html2canvas"
  import jsPDF from "jspdf";

export default {
  name: "report-summary-2",
  props: ['report', 'project'],
  mounted() {
    setTimeout(() => {
      this.render();
    }, 2000)
  },
  methods: {
    getSeries(report) {
      return {
        exposureS: [{name: 'exposure, s', data: [...report.map(i => i.exposure_time_sec)]}],
        exposurePt: [{name: 'exposure, %', data: [...report.map(i => i.exposure_time_pct)]}],
        areaPt: [{name: 'mean area, %', data: [...report.map(i => i.mean_area_pct)]}],
        bis: [{name: 'bis', data: [...report.map(i => i.bis.toFixed(2))]}]
      }
    },
    render() {
      const data = this.getSeries(this.report);

      const expTimeSecChart = new ApexCharts(document.querySelector("#exp-time-s"), getOptions(data.exposureS));
      const expTimePercentChart = new ApexCharts(document.querySelector("#exp-time-percent"), getOptions(data.exposurePt));
      const meanAreaPercentChart = new ApexCharts(document.querySelector("#mean-area-percent"), getOptions(data.areaPt));
      const bisChart = new ApexCharts(document.querySelector("#bis"), getOptions(data.bis));

      try {
        expTimePercentChart.render();
        expTimeSecChart.render();
        meanAreaPercentChart.render();
        bisChart.render();
      } catch (e) {
        console.log(e);
      }
    },
    async save() {
      html2canvas(this.$refs.reportSummary2).then((canvas) => {
        const img = canvas.toDataURL("image/jpeg");
        console.log(img, canvas, canvas.width, canvas.height);
          const doc = new jsPDF();
          console.log(doc)

          doc.addImage(img, 'JPEG', 5, 2, 205, 295, '1', 'NONE');
          doc.save("test.pdf");
      });
    },
  },
}
</script>
<style scoped>
  /* --------------------------------------------------------------

   typography.css
   * Sets up some sensible default typography.
   http://www.blueprintcss.org/blueprint/src/typography.css
-------------------------------------------------------------- */

  /* Default font persons.
     The font-size percentage is of 16px. (0.75 * 16px = 12px) */

  html { font-size:100.01%; }
  body, .body {
    font-size: 75%;
    color: #222;
    background: #fff;
    font-family: "AcronisCyber", "Helvetica Neue", Arial, Helvetica, sans-serif;
    box-sizing: unset;
  }


  /* Headings
  -------------------------------------------------------------- */

  h1,h2,h3,h4,h5,h6 { font-weight: bold; font-family: "AcronisCyberBold", sans-serif}

  h1 { font-size: 3em; line-height: 1; margin-bottom: 0.5em; }
  h2 { font-size: 2em; margin-bottom: 0.75em; }
  h3 { font-size: 1.5em; line-height: 1; margin-bottom: 1em; }
  h4 { font-size: 1.2em; line-height: 1.25; margin-bottom: 1.25em; }
  h5 { font-size: 1em; font-weight: bold; margin-bottom: 1.5em; }
  h6 { font-size: 1em; font-weight: bold; }

  h1 img, h2 img, h3 img,
  h4 img, h5 img, h6 img {
    margin: 0;
  }


  /* Text elements
  -------------------------------------------------------------- */

  p           { margin: 0 0 1.5em; }
  /*
      These can be used to pull an image at the start of a paragraph, so
      that the text flows around it (usage: <p><img class="left">Text</p>)
   */
  .left  			{ float: left !important; }
  p .left			{ margin: 1.5em 1.5em 1.5em 0; padding: 0; }
  .right 			{ float: right !important; }
  p .right 		{ margin: 1.5em 0 1.5em 1.5em; padding: 0; }

  a:focus,
  a:hover     { color: #09f; }
  a           { color: #06c; text-decoration: underline; }

  blockquote  { margin: 1.5em; color: #666; font-style: italic; }
  strong,dfn	{ font-weight: bold; }
  em,dfn      { font-style: italic; }
  sup, sub    { line-height: 0; }

  abbr,
  acronym     { border-bottom: 1px dotted #666; }
  address     { margin: 0 0 1.5em; font-style: italic; }
  del         { color:#666; }

  pre         { margin: 1.5em 0; white-space: pre; }
  pre,code,tt { font: 1em 'andale mono', 'lucida console', monospace; line-height: 1.5; }


  /* Lists
  -------------------------------------------------------------- */

  li ul,
  li ol       { margin: 0; }
  ul, ol      { margin: 0 1.5em 1.5em 0; padding-left: 1.5em; }

  ul          { list-style-type: disc; }
  ol          { list-style-type: decimal; }

  dl          { margin: 0 0 1.5em 0; }
  dl dt       { font-weight: bold; }
  dd          { margin-left: 1.5em;}


  /* Tables
  -------------------------------------------------------------- */

  /*
      Because of the need for padding on TH and TD, the vertical rhythm
      on table cells has to be 27px, instead of the standard 18px or 36px
      of other elements.
   */
  /*table       { margin-bottom: 1.4em; width:100%; }*/
  /*th          { font-weight: bold; text-align: center }*/
  /*thead th    { background: #c3d9ff; }*/
  /*th,td,caption { padding: 4px 10px 4px 5px; }*/
  /*
      You can zebra-stripe your tables in outdated browsers by adding
      the class "even" to every other table row.
   */
  /*tbody tr:nth-child(even) td,*/
  /*tbody tr.even td  {*/
  /*background: #e5ecf9;*/
  /*}*/
  /*tfoot       { font-style: italic; }*/
  /*caption     { background: #eee; }*/

  /* Misc classes
  -------------------------------------------------------------- */

  .small      { font-size: .8em; margin-bottom: 1.875em; line-height: 1.875em; }
  .large      { font-size: 1.2em; line-height: 2.5em; margin-bottom: 1.25em; }
  .hide       { display: none; }

  .quiet      { color: #666; }
  .loud       { color: #000; }
  .highlight  { background:#ff0; }
  .added      { background:#060; color: #fff; }
  .removed    { background:#900; color: #fff; }

  .first      { margin-left:0; padding-left:0; }
  .last       { margin-right:0; padding-right:0; }
  .top        { margin-top:0; padding-top:0; }
  .bottom     { margin-bottom:0; padding-bottom:0; }

  body, html, .body {
    box-sizing: unset;
    padding: 0;
    height: 860px;
    /*transform: scale(1.15);*/
  }

  .body {
    /*margin: 0 auto;*/
    /*margin-top: 10%;*/
  }

  .math {
    margin-top: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px !important;
    line-height: 15px;
    color: #00204D;
  }

  svg {
    transform: translateX(-3.4%) scale(1.11);
  }

  header {
    border-top: 0.5px solid #00204D;
    padding-top: 10px;
    display: flex;
    margin-bottom: 120px;
  }

  .pdf-footer {
    position: absolute;
    bottom: 0;
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px solid #00204D;
  }

  section {
    display: flex;
  }

  span, h3, th, td, div {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #00204D;
    text-align: left;
  }

  th {
    margin-right: 10px;
  }

  .table-cell {
    text-align: center;
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #00204D;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin-right: 10px;
  }

  h3 {
    font-weight: bold;
    margin: 0;
  }

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: #00204D;
    margin: 0;
    width: 340px;
    word-break: break-word;
  }

  .table-row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-bottom: 9px;

    position: static;
    width: 340px;
    height: 11px;
    left: 0px;
    top: 0px;

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 9px 0px;

    border-bottom: 0.5px solid #00204D;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .no-border {
    border: none;
    height: 11px;
  }

  .no-padding {
    padding: 0;
  }

  .pt-20 {
    padding-top: 20px;
  }

  .mt-45 {
    margin-top: 45px;
  }

  .mt-30 {
    margin-top: 30px;
  }

  .mt-25 {
    margin-top: 25px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .no-margin {
    margin: 0;
  }

  .container {
    position: relative;
    width: 510px;
    height: 780px;
    background: #FFFFFF;
    margin: 0 auto;
  }

  .pdf-wrapper {
    position: relative;
    width: 593px;
    background: #FFFFFF;
    margin: 0 auto;
    padding: 30px 0;
  }

  .date {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #00204D;
    margin: 0;
    margin-bottom: 10px;
  }

  .side-content {
    width: 150px;
    margin-right: 20px;
  }

  .side-content-2 {
    width: 320px;
    margin-right: 20px;
  }

  .main-content-2 {
    width: 170px;
    box-sizing: unset;
  }

  .main-content {
    width: 340px;
  }

  .content-heading {
    padding-bottom: 10px;
    border-bottom: 2px solid #00204D;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #00204D;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-heading > span {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    text-align: right;
    color: #00204D;
  }

  .content-heading--sec {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 10px;
    display: flex;
    align-items: flex-end;
    color: #727984;
    padding-bottom: 10px;
    border-bottom: 2px solid #00204D;
    max-height: 20px;
    box-sizing: unset;
  }

  .logo {
    margin-right: 20px;
    width: 150px;
    height: 20px;
  }

  .logo-text {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 10px;
    color: #727984;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 10px 0px;
    width: 150px;
  }

  .thumbnail {
    width: 150px;
    height: 84px;
    background: rgba(36, 49, 67, 0.1);
    margin: 20px 0;
    object-fit: cover;
  }

  .field {
    margin-bottom: 10px;
    word-break: break-word;
  }

  .page-row {
    display: flex;
  }

  .apexcharts-zoom-icon, .apexcharts-reset-icon, .apexcharts-menu-icon {
    display: none;
  }

  .apexcharts-yaxis-label {
    margin-bottom: 9px;
  }

  .heatmap-story {
    display: block;
    margin-top: 40px;
    width: 320px;
  }

  .heatmap-story-row {
    display: flex;
    align-items: center;
  }

  .heatmap-gradient {
    height: 84px;
    margin-top: 10px;
    margin-left: 20px;
  }

  .arrows {
    height: 82px;
    border-top: 1px solid;
    border-bottom: 1px solid;
    width: 20px;
    margin-top: 10px;
  }

  .more, .less {
    margin-left: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 11px;
    display: flex;
    align-items: flex-end;
    color: #00204D;
  }

  .more {
    margin-bottom: 60px;
  }

  .less {
    margin-bottom: -5px;
  }

  .heatmap-img {
    margin-top: 10px;
    height: 84px;
    width: 150px;
  }

  .heatmap-container {
    display: grid;
    grid-template-columns: 150px 150px 150px;
    grid-gap: 20px;
    grid-row-gap: 40px;
    flex-wrap: wrap;
  }

  .heatmap {
    flex: 1;
  }

  .no-margin-x {
    margin-left: 0;
    margin-right: 0;
  }

  .para2 {
    max-width: 170px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .para {
    max-width: 150px;
    margin-top: 10px;
    word-break: break-word;
  }

  .formula-row {
    display: flex;
    align-items: flex-start;
    max-width: 150px;
  }

  .formula-row > span {
    max-width: 120px;
  }

  .formula-char {
    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 11px;
    display: flex;
    align-items: flex-end;
    color: #00204D;
    width: 20px;
  }

</style>
